import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2025 from '../SchoolProgram2023/components/Sidebar2025';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const OnamandEidCelebration2026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/7.webp`;
    const p8 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/8.webp`;
    const p9 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/9.webp`;
    const p10 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/10.webp`;
    const p11= `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/11.webp`;
    const p12= `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/12.webp`;
    const p13= `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/13.webp`;
    const p14= `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/14.webp`;
    const p15 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/15.webp`;
    const p16 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/16.webp`;
    const p17= `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/17.webp`;
    const p18 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/18.webp`;
    const p19 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/19.webp`;
    const p20 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/20.webp`;
    const p21 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/21.webp`;
    const p22 = `${config.base_image_url_2026}/home/events-activities/school-programs/OnamandEid/22.webp`;




    const photos = [
       
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
         {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
         {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
         {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
        },
        {
            src: p8,
            source: p8,
            rows: 1,
            cols: 1,
        },
        {
            src: p9,
            source: p9,
            rows: 1,
            cols: 1,
        },
        {
            src: p10,
            source: p10,
            rows: 1,
            cols: 1,
        },
        {
            src: p11,
            source: p11,
            rows: 1,
            cols: 1,
        },
        {
            src: p12,
            source: p12,
            rows: 1,
            cols: 1,
        },
        {
            src: p13,
            source: p13,
            rows: 1,
            cols: 1,
        },
        {
            src: p14,
            source: p14,
            rows: 1,
            cols: 1,
        },
        {
            src: p15,
            source: p15,
            rows: 1,
            cols: 1,
        },
        {
            src: p16,
            source: p16,
            rows: 1,
            cols: 1,
        },
        {
            src: p17,
            source: p17,
            rows: 1,
            cols: 1,
        },
        {
            src: p18,
            source: p18,
            rows: 1,
            cols: 1,
        },
        {
            src: p19,
            source: p19,
            rows: 1,
            cols: 1,
        },
        {
            src: p20,
            source: p20,
            rows: 1,
            cols: 1,
        },
        {
            src: p21,
            source: p21,
            rows: 1,
            cols: 1,
        },
        {
            src: p22,
            source: p22,
            rows: 1,
            cols: 1,
        },

        
    
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                          Topic: Onam and Eid Milad
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                Date: 25 AUGUST 2026
                                </Typography>
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
“Onam and Eid bring us together in the spirit of love, harmony and brotherhood, reminding us that every
celebration is more beautiful when shared.”
                                <br />
                            </Typography> 

                                <br />
      <Typography variant={'subtitle1'} align={'justify'}>
The students of National Public School, Yeshwanthpur, came together to celebrate the vibrant spirit of Onam and Eid
Milad on Tuesday, 25 August 2026. The celebration of Onam and Eid Milad began with a warm welcome and an
inspiring thought, followed by a skit highlighting the significance of both the festivals. The venue was beautifully
adorned with a colourful and intricately designed pookalam, adding a traditional touch to the festive ambience.
A soulful group song by Classes 4 and 5 and the graceful Thiruvathirakali by the Montessori and Kindergarten
students further enhanced the festive spirit.
 <br></br>
The celebrations continued with a lively Kaikottikali by Class 1 students, followed by an energetic folk dance
drama by Classes 2, 3 and 5. The Class 8B students added vibrancy with their dance performance, leading to a
spectacular culmination dance. Each performance beautifully reflected the rich traditions, joy and togetherness
associated with the celebrations.
 <br></br>
The programme concluded with the concluding skit, an inspiring address by the Principal Ma’am and a heartfelt
vote of thanks. The celebration truly captured the essence of Onam and Eid Milad—love, peace, harmony,
gratitude and togetherness, leaving everyone with hearts full of joy and the warmth of shared celebrations.
 <br></br>

</Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
Festivals may have different traditions, but their essence remains the same — love, kindness, peace
and togetherness.
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default OnamandEidCelebration2026;